export const toursIDs = {
  tourZacahuil: "3c1ec841-8f6b-4a65-ad0c-0dad80dae5ee",
  tourBocoles: "2e00fa1a-8214-49e8-a265-efd0de9537f1",
  tourEnchiladas: "4939b3ea-9a75-4172-bdf9-e83865205fbf",
  tourAcamayas: "e2b61d87-4e3f-40af-9297-ef70fefbd13d",
  tourMojarras: "a9000256-78a3-46ec-a246-54627b4aa9ab",
  tourMarranada: "748fe2ef-de51-406e-b8a8-466c43ca230d",
  tourArqueologico: "3e08421e-e4eb-4f56-9408-4dfd4218b55e",
};

export const tours4X4IDs = {
  rutaNacimiento: "ea41bf8e-c08b-461d-b7a2-44f4ac471927",
  rutaTrinidad: "163f1e8a-30fe-4f64-a9ce-3a4b13c7869a",
  rutaSurrealista: "ad72db1b-738d-4fe3-8cf0-1cab3fd5bb1a",
  rutaMiradores: "650dcf18-f688-4b73-bc54-a7c8fb965e28",
  rutaNanacatli: "5151d310-7705-4b0f-980e-63219fd942bc",
};
